export default __webpack_public_path__ + "static/media/no-results.70deb37e.svg";